<template>

    <page-heading page-title="Pracuj z nami" buttons="{buttons_with_href_obj}"/>

    <div class="px-2 max-w-md mx-auto sm:max-w-3xl">

        <!--ABOUT-->
        <div>

            <div>
                <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 48 48"
                     aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M34 40h10v-4a6 6 0 00-10.712-3.714M34 40H14m20 0v-4a9.971 9.971 0 00-.712-3.714M14 40H4v-4a6 6 0 0110.713-3.714M14 40v-4c0-1.313.253-2.566.713-3.714m0 0A10.003 10.003 0 0124 26c4.21 0 7.813 2.602 9.288 6.286M30 14a6 6 0 11-12 0 6 6 0 0112 0zm12 6a4 4 0 11-8 0 4 4 0 018 0zm-28 0a4 4 0 11-8 0 4 4 0 018 0z"/>
                </svg>
                <p class="p-2 text-center font-bold text-lg text-gray-500">Razem z nami dostarczaj produkty i usługi
                    najwyższej jakości!</p>

                <p class="mt-4 text-sm text-gray-500">Jesteśmy firmą z wieloletnim doświadczeniem o ugruntowanej pozycji
                    na rynku handlu detalicznego. Dbamy o wysoką jakość oferowanych produktów. Wiemy jednak, że handel
                    tworzą ludzie. Dlatego już w procesie rekrutacji stawiamy na jasną komunikację i kładziemy nacisk na
                    precyzyjną informację o szczegółach naszej oferty.</p>


                <h2 class="mt-4">Zapewniamy:</h2>
                <ul class="list-disc pl-6 mt-1 text-sm text-gray-500">
                    <li>gwarancję stabilnego zatrudnienia na umowę o pracę</li>
                    <li>pracę w pełnym wymiarze godzin</li>
                    <li>bezpłatną, prywatną opiekę medyczną</li>
                    <li>możliwość przystąpienia do ubezpieczenia grupowego dla Ciebie i Twoich bliskich</li>
                    <li> bony na święta</li>
                    <li>atrakcyjne warunki wynagrodzenia</li>
                </ul>


                <h2 class="mt-4">Wymagamy:</h2>
                <ul class="list-disc pl-6 mt-1 text-sm text-gray-500">
                    <li>energiczność, dokładność i zaangażowanie w wykonywane zadania</li>
                    <li>kultura osobista oraz pozytywne nastawienie do klienta</li>
                    <li>sumienność i uczciwość</li>
                    <li>umiejętność pracy w zespole</li>
                    <li>gotowość do pracy w systemie zmianowym oraz w soboty</li>
                    <li>książeczka sanitarną - epidemiologiczna lub gotowość do jej wyrobienia</li>
                    <li>doświadczenie w pracy w branży spożywczej będzie dodatkowym atutem</li>
                </ul>

            </div>

        </div>

        <!--JOB OFFERS-->
        <div class="my-20 sm:mx-10 mx-5">
            <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wide text-center">Aktualne oferty
                pracy</h3>
            <div class="flow-root mt-6">
                <ul role="list" class="-my-5 divide-y divide-gray-200">
                    <li v-for="offer in offers" :key="offer.id" class="py-4">
                        <div class="flex items-center space-x-4">
                            <!--                            <div class="flex-shrink-0">-->
                            <!--                                <img class="h-8 w-8 rounded-full" :src="offer.imageUrl" alt=""/>-->
                            <!--                            </div>-->
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-medium text-gray-900 truncate">
                                    {{ offer.title }}
                                    <span style="font-size: 10px"
                                          class="m-1 inline-flex items-center px-2 py-0 rounded font-medium bg-indigo-100 text-indigo-800">
                                    {{ offer.workplace }}
                                  </span>
                                </p>
                                <p class="text-sm text-gray-500 truncate">
                                    {{ offer.departmentName }}
                                </p>
                            </div>
                            <div>
                                <a href="#offerDescription" @click="fetchOffer(offer.id)"
                                   class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50">
                                    Więcej
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>


        <!--JOB DESCRIPTION-->
        <div id="offerDescription" class="mt-10"></div>
        <div v-if="title === null">
            <p class="text-center text-gray-500">Wybierz stanowisko aby poznać szczegóły oferty</p>
        </div>
        <div v-else>
            <section aria-labelledby="applicant-information-title">
                <div class="bg-white shadow sm:rounded-lg">
                    <div class="px-4 py-5 sm:px-6 flex justify-center">
                        <img class="max-h-20 p-1" :src="departmentLogo" :alt="departmentName"/>
                    </div>
                    <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
                        <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                            <div class="sm:col-span-1">
                                <dt class="text-sm font-medium text-gray-500">
                                    Stanowisko
                                </dt>
                                <dd class="mt-1 text-sm text-gray-900">
                                    {{ title }}
                                </dd>
                            </div>
                            <div class="sm:col-span-1">
                                <dt class="text-sm font-medium text-gray-500">
                                    Wynagrodzenie
                                </dt>
                                <dd class="mt-1 text-sm text-gray-900">
                                    {{ salary }}
                                </dd>
                            </div>


                            <div class="sm:col-span-1">
                                <dt class="text-sm font-medium text-gray-500">
                                    Nazwa placówki
                                </dt>
                                <dd class="mt-1 text-sm text-gray-900">
                                    {{ departmentName }}
                                </dd>
                            </div>
                            <div class="sm:col-span-1">
                                <dt class="text-sm font-medium text-gray-500">
                                    Adres placówki
                                </dt>
                                <dd class="mt-1 text-sm text-gray-900">
                                    {{ departmentAddress }}
                                </dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium text-gray-500">
                                    Opis
                                </dt>
                                <dd class="mt-1 text-sm text-gray-900" v-html="description"></dd>
                                <p>{{ contactMessageType }}</p>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium text-gray-500">
                                    Zakres obowiązków
                                </dt>
                                <div class="pl-6 mt-1 text-sm text-gray-900 trix-styles"
                                     v-html="responsibilities"></div>
                            </div>

                            <div class="sm:col-span-2">
                                <div class="text-center">
                                    <a :href="`tel:${phone}`"
                                       class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Zadzwoń
                                        do rekrutera</a>
                                </div>
                            </div>

<!--                            <div class="sm:col-span-2">-->
<!--                                <dt class="text-sm font-medium text-gray-500">-->
<!--                                    Załączniki-->
<!--                                </dt>-->
<!--                                <dd class="mt-1 text-sm text-gray-900">-->
<!--                                    <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">-->

<!--                                        <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">-->
<!--                                            <div class="w-0 flex-1 flex items-center">-->
<!--                                                <svg class="flex-shrink-0 h-5 w-5 text-gray-400"-->
<!--                                                     x-description="Heroicon name: solid/paper-clip"-->
<!--                                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"-->
<!--                                                     fill="currentColor" aria-hidden="true">-->
<!--                                                    <path fill-rule="evenodd"-->
<!--                                                          d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"-->
<!--                                                          clip-rule="evenodd"></path>-->
<!--                                                </svg>-->
<!--                                                <span class="ml-2 flex-1 w-0 truncate">polityka_prywatnosci.pdf</span>-->
<!--                                            </div>-->
<!--                                            <div class="ml-4 flex-shrink-0">-->
<!--                                                <a href="#" class="font-medium text-blue-600 hover:text-blue-500">-->
<!--                                                    Pobierz-->
<!--                                                </a>-->
<!--                                            </div>-->
<!--                                        </li>-->

<!--                                    </ul>-->
<!--                                </dd>-->
<!--                            </div>-->

                        </dl>
                    </div>


                    <div>
                        <router-link
                            :to="{ name: 'contact', params: {type: 'hr', jobOfferTitle: title + ' w ' + departmentName, jobOfferId: jobOfferId } }"
                            class="block bg-gray-50 text-sm font-medium text-gray-500 text-center px-4 py-4 hover:text-gray-700 sm:rounded-b-lg">
                            Aplikuj
                        </router-link>
                    </div>
                </div>
            </section>

        </div>

    </div>
</template>

<script>
import PageHeading from "../components/layout/PageHeading";
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverOverlay,
    PopoverPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import {
    ArrowNarrowLeftIcon,
    CheckIcon,
    HomeIcon,
    PaperClipIcon,
    QuestionMarkCircleIcon,
    SearchIcon,
    ThumbUpIcon,
    UserIcon,
} from '@heroicons/vue/solid'
import {BellIcon, MenuIcon, XIcon} from '@heroicons/vue/outline'

let offers;

export default {
    name: "JobsPage",
    components: {
        PageHeading,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        Popover,
        PopoverButton,
        PopoverOverlay,
        PopoverPanel,
        TransitionChild,
        TransitionRoot,
        ArrowNarrowLeftIcon,
        BellIcon,
        HomeIcon,
        MenuIcon,
        PaperClipIcon,
        QuestionMarkCircleIcon,
        SearchIcon,
        XIcon,
    },
    data: () => ({
        title: null,
        workplace: null,
        description: null,
        departmentName: null,
        departmentLogo: null,
        phone: null,
        departmentAddress: null,
        responsibilities: null,
        salary: null,
        offers,
    }),

    created: function () {
        this.getOffers()
    },
    methods: {
        async fetchOffer(id) {
            await fetch(`https://cloudpanel.pl/api/uchowanca/jobOffer/${id}`)
                .then(response => response.json())
                .then(result => {
                    this.jobOfferId = result.result.id;
                    this.title = result.result.title;
                    this.workplace = result.result.workplace;
                    this.departmentName = result.result.departmentName;
                    this.departmentLogo = result.result.departmentLogo;
                    this.phone = result.result.phone;
                    this.departmentAddress = result.result.departmentAddress;
                    this.description = result.result.description;
                    this.responsibilities = result.result.responsibilities;
                    this.salary = result.result.salary;
                });
        },
        async getOffers() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/jobOffers`)
                .then(response => response.json())
                .then(result => {
                    this.offers = result.offers;
                    console.log(result.offers)
                });
        }
    }
}

</script>
